import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../brand-colors';

function BusinessEngineer() {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Business Strategist',
      icon: '\uD83E\uDDD1\u200D\uD83D\uDCBC',
      description: 'AI-powered business guidance — get strategic advice on pricing, positioning, growth, and operations.',
      path: '/command-center/business-engineer/profit-advisor',
      buttonText: 'Open Business Strategist',
      color: colors.goldMid
    },
    {
      title: 'SOP Assistant',
      icon: '\uD83D\uDCCB',
      description: 'Build standard operating procedures for your business processes — systemize what you do so your business runs without you.',
      path: '/command-center/business-engineer/sop-assistant',
      buttonText: 'Open SOP Assistant',
      color: colors.navy
    },
    {
      title: 'Case Study Writer',
      icon: '\uD83C\uDFC6',
      description: 'Turn customer wins into compelling case studies that build trust and drive sales.',
      path: '/command-center/business-engineer/case-study',
      buttonText: 'Write Case Study',
      color: '#9B59B6'
    },
    {
      title: 'Customer Experience Design',
      icon: '🎯',
      description: 'Define the customer journey: purchase, onboarding, ongoing use, success metrics, and retention touchpoints.',
      path: '/command-center/business-engineer/customer-experience',
      buttonText: 'Design Experience',
      color: colors.goldDark
    },
    {
      title: 'Profit Zone',
      icon: '\uD83D\uDCB0',
      description: 'AI-driven revenue strategies and implementation — identify opportunities to boost income, then set the wheels in motion.',
      path: '/command-center/business-engineer/profit-zone',
      buttonText: 'Open Profit Zone',
      color: '#27ae60'
    }
  ];

  return (
    <Container className="py-4">
      <div className="mb-4">
        <h1 style={{
          fontFamily: "'Trajan Pro', 'Trajan Pro 3', 'Times New Roman', serif",
          letterSpacing: '0.15em',
        }}>Business Engineer</h1>
        <p className="text-muted">
          Optimize your operations — AI-powered advice, systematized processes, and proof that sells.
        </p>
      </div>

      <Row>
        {cards.map((card) => (
          <Col key={card.title} md={6} className="mb-4">
            <Card
              className="h-100 shadow-sm"
              style={{
                border: `1px solid ${colors.greyLight}`,
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onClick={() => navigate(card.path)}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = colors.goldMid;
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = colors.greyLight;
                e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <Card.Header style={{
                backgroundColor: colors.greyDarkest,
                color: colors.goldLight,
                fontFamily: "'Trajan Pro', 'Trajan Pro 3', 'Times New Roman', serif",
                letterSpacing: '0.1em',
              }}>
                <strong>{card.title}</strong>
              </Card.Header>
              <Card.Body className="d-flex flex-column p-4">
                <p className="text-muted flex-grow-1">{card.description}</p>
                <Button
                  variant="outline-dark"
                  className="mt-auto"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(card.path);
                  }}
                >
                  Open {card.title} →
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default BusinessEngineer;
